import AepProviders from '@components/pages/account/aep/providers';

export default AepProviders;
